/* eslint-disable import/no-cycle */
import { LOGIN_API_PATH, SET_USER_API_PATH } from '../../service/path';
import {
  LOGIN, LOGOUT, SET_TOKEN, SET_USER
} from './types';
import { api, saveTokenAuthentication, setAuthentication } from '../../service/api';
import { showErrorMessage } from '../../utils/utils';

export const setUser = () => (dispatch) => dispatch({
  type: SET_USER,
  promise: api.get(SET_USER_API_PATH),
});

export const setToken = (tokens) => (dispatch) => dispatch({
  type: SET_TOKEN,
  tokens,
});

export const login = (data, callback) => (dispatch) => dispatch({
  type: LOGIN,
  promise: api.post(LOGIN_API_PATH, data),
  meta: {
    onSuccess: (res) => {
      setAuthentication(res.data.tokens.accessToken);
      saveTokenAuthentication(res.data.tokens, res.data.user.rol);
      dispatch(setToken(res.data.tokens));
      callback();
    },
    onFailure: (res) => {
      console.log('res', res);
      showErrorMessage(res.response.data.message, dispatch);
    }
  }
});

export const logout = () => (dispatch) => dispatch({
  type: LOGOUT,
});
export const resetStore = () => ({
  type: 'RESET'
});

// const sendEmail = (email, callback) => (dispatch) => dispatch({
//   type: SEND_EMAIL,
//   promise: api.post(RESET_PASSWORD_PATH, {
//     email
//   }),
//   meta: {
//     onSuccess: (res) => {
//       showSuccessMessage(res.data.message, dispatch);
//       callback();
//     },
//     onFailure: (res) => {
//       showErrorMessage(res.response.data.message, dispatch);
//       callback();
//     }

//   }
// });
// const newPassword = (data) => (dispatch) => dispatch({
//   type: RESET_PASS,
//   promise: api.post(CHANGE_PASSWORD_PATH, data),
//   meta: {
//     onSuccess: (res) => {
//       showSuccessMessage(res.data.message, dispatch);
//     },
//     onFailure: (res) => {
//       showErrorMessage(res.response.data.message, dispatch);
//     }

//   }
// });
